import { memo } from "react";
import { TableHeaderProps } from "./table.interface";

const TableHeaderCell = ({ sortIndex, activeColumn, item }: TableHeaderProps) => {

    function setHeaderColumnClass(name: string): string {
        if (item?.sortDisabled) {
            return 'disable';
        }
        if (sortIndex < 1 && activeColumn == name) {
            return 'asc';
        } else if (sortIndex > -1 && activeColumn == name) {
            return 'desc';
        } else {
            return '';
        }
    }

    function handleClick(): void {
        if (item.func && !item.sortDisabled) {
            item.func(item.name);
        }
    }

    return (
        <a title={item?.tooltip}
            data-cy={item.name}
            className={`index-header-category sort ${item.className} ` + (setHeaderColumnClass(item.name))}
            style={{ width: `${item.width}%` }}
            onClick={handleClick}>
            <span>
                {item.title}
            </span>
        </a>
    );
};

export default memo(TableHeaderCell);